<template>
    <div class='wrapper'>
        <dots id="dots"></dots>
        <h1 class="page-title">{{currentAction.name}}</h1>
        <div class="page-content" v-html="currentAction.description"></div>

        <div class="investigation-group row">
            <div v-for="(inv, i) in currentAction.investigation" :key="i" class="investigation-item col c12">
                <router-link :to="investigationPath( i )">
                    <i class="bi" :class="inv.icon"></i>
                    <div class="placeholder"></div>
                    {{ inv.title }}
                </router-link>
            </div>
        </div>

        <div class="sticky-footer">
            <button class="btn center noselect" @click="animateOut">Next</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Dots from '@/components/Dots.vue';
    import { gsap } from '/src/assets/js/gsap';
    import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin';

    export default {
        name : "Step",
        components: {
            'dots' : Dots
        },
        computed : {
            ...mapGetters([
                'currentAction'
            ]),
            content(){
                return this.currentAction
            }
        },
        methods : {
            investigationPath( i ){
                const p = this.$router.currentRoute.path
                const s = this.currentAction.investigation[ i ].slug
                return p + "/investigate/" + s
            },
            decisionPath(){
                const p = this.$router.currentRoute.path
                return p + "/decision"
            },
            animateOut() {
                gsap.to('#dots, h1, img, p, li, .investigation-item, button', {autoAlpha: 0, stagger: { amount: 0.35}, ease: "back.in"});
                gsap.delayedCall(1, this.next);
            },
            next() {
                this.$router.push({ path: this.decisionPath() });
            }
        },
        mounted () {
            gsap.registerPlugin( ScrollToPlugin )
            this.$parent.appHeight()
            const tl = new gsap.timeline();
            tl.to( window, { duration : 0.35, scrollTo : 0, delay : .2, ease : "sine.out" });
            tl.from('#dots, h1, img, p, li, .investigation-item, button', {autoAlpha: 0, x: "-50px", stagger: { amount: 0.35}, ease: "sine.out"}, "+=0.25");
        }
    }
</script>